<template>
    <div class="rounded-md border p-4" :class="[bgColor, borderColor]">
        <slot />
    </div>
</template>

<script>
export default {
    // defaults to green box
    name: 'InfoBox',
    props: {
        bgColor: {
            type: String,
            default: 'bg-[#eaf5ec]',
        },
        borderColor: {
            type: String,
            default: 'border-[#b4e6bd]',
        },
    },
};
</script>
